import { COLORS } from '../constants/colors';
import { CONTENTFUL_NAMES } from '../constants/contentful';
import { courierEcommerceUrl } from '../constants/url';

export { default as getFormattedDate } from './get-formatted-date';

export const generateSlug = (str) =>
  str
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');

export const everyNth = (n, i) => i % n === n - 1;

export const toCamelCase = (str) => {
  if (!str) return '';
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase(),
    )
    .replace(/\s+/g, '');
};

export const getPerformanceCookie = (window) => {
  const cookies = window.OptanonActiveGroups;
  return cookies ? cookies.split(',').indexOf('2') !== -1 : true;
};

export const checkRequired = (...args) =>
  args.filter((val) => val === null).length === 0;

export const hasRequiredContentfulFields = (...args) => {
  return args.every((val) => val !== null);
};

export const shouldFreddieInverse = ({
  backgroundColorName,
  textColorName,
}) => {
  if (
    backgroundColorName === 'french' ||
    backgroundColorName === 'squidInk' ||
    textColorName === 'snow'
  )
    return true;

  return false;
};

export const getArticleHeaderTheme = ({
  backgroundColorName,
  textColorName,
}) => {
  const isFreddieInverse = shouldFreddieInverse({
    backgroundColorName,
    textColorName,
  });
  return {
    backgroundColor: COLORS[backgroundColorName],
    isFreddieInverse,
    textColor: COLORS[textColorName],
  };
};

export const isExternal = (url) => {
  const r = new RegExp('^(?:[a-z]+:)?//', 'i');

  return r.test(url);
};

// transformers
export const transformArticleData = (data) => {

  return {
    ...data,
    date: data.publishedDate,
    description: data?.header?.headline,
    franchise: {
      name: data?.franchise?.franchiseName,
      url: `/${data?.franchise?.slug}`,
    },
    image: data?.cardImage,
    tags: data?.tags?.map((tag) => {
      return {
        name: tag.name,
        url: `/${tag.type}/${tag.slug}/`,
      };
    }),
    url: `/article/${data?.slug}`,
  };
};

export const transformArticleContentCardData = (data) => {
  const url = data.link?.url;
  const getUrl = isExternal(url) ? url : `${courierEcommerceUrl}${url}`;
  return {
    id: data.link.id,
    image: data.image,
    tags: [{ name: data?.tag, url: getUrl }],
    title: data?.title,
    url: getUrl,
  };
};

export const transformCardImageBasedXLargeData = (data) => {
  return data.map((item) => {
    const type = item?.internal?.type;

    switch (type) {
      case CONTENTFUL_NAMES.ContentfulArticleLongForm:
      case CONTENTFUL_NAMES.ContentfulArticleList:
        return transformArticleData(item);

      case CONTENTFUL_NAMES.ContentfulArticleContentCard:
        return transformArticleContentCardData(item);
      default:
        return null;
    }
  });
};

export const getArticleUrl = ({ slug, type }) => {
  switch (type) {
    case CONTENTFUL_NAMES.ContentfulArticleLongForm:
    case CONTENTFUL_NAMES.ContentfulArticleList:
      return `/article/${slug}/`;
    case CONTENTFUL_NAMES.ContentfulArticlePodcast:
      return `/podcast/${slug}/`;
    case CONTENTFUL_NAMES.ContentfulStory:
      return `/story/${slug}/`;
    default:
      return '/';
  }
};
